import { observer } from 'mobx-react';
import { isNil } from 'ramda';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router';
import styled from 'styled-components';
import { Paths } from '~admin/route';
import { useAdminAuthStore } from '~admin/store/admin-auth-store-provider';
import { LoginForm } from '~admin/view/components/auth/login-form.component';
import { LoginPageQueryParameters } from '~admin/view/pages/parameters';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';
import { Title } from '~common/components/title.component';
import { Logo } from '~common/components/icon/logo.icon';

export const LoginPage: React.FunctionComponent<LoginPageQueryParameters> = observer(
  ({ redirect }) => {
    const adminAuthStore = useAdminAuthStore();
    const { authenticated } = adminAuthStore;
    const { t } = useTranslation();

    if (authenticated) {
      return <Redirect to={isNil(redirect) ? Paths.tool.base : redirect} />;
    }

    return (
      <Container>
        <Content>
          <Logo />
          <StyledTitle>{t('login.title')}</StyledTitle>
          <BorderBox>
            <LoginForm />
          </BorderBox>
        </Content>
      </Container>
    );
  },
);

const Container = styled(Column)`
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const Content = styled(Column)`
  align-items: center;
  width: 100%;
  max-width: 500px;
`;

const StyledTitle = styled(Title)`
  margin: 20px 0;
`;

const BorderBox = styled(Box)`
  width: 100%;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;
`;



// WEBPACK FOOTER //
// ./view/pages/auth/login.page.tsx